// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { prop65WarningStyles } from "@sc/App/Widgets/Prop65Warning/Prop65Warning";
import Prop65WarningIcon from "@sc/XDL/Icons/Prop65WarningIcon";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

prop65WarningStyles.wrapperContainer = {
    css: css`
        padding: 12px;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        margin-bottom: 24px;
        ${xScreen("lte", "md")} {
            margin-bottom: 0;
            height: calc(100% - 24px);
            margin-top: 24px;
        }
    `,
};

prop65WarningStyles.title = {
    variant: "h4",
    forwardAs: "p",
};

prop65WarningStyles.IconWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
    `,
};

prop65WarningStyles.subTitle = {
    size: 16,
    lineHeight: "17px",
    weight: "bold",
};

prop65WarningStyles.warningIcon = {
    size: 16,
    src: Prop65WarningIcon,
    color: "warning.main",
    css: css`
        opacity: 0.66;
    `,
};

prop65WarningStyles.content = {
    size: 16,
    lineHeight: "26px",
    css: css`
        & ${TypographyStyle} {
            font-size: 16px;
        }
    `,
};
